import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { translateResourceString } from '../../../util/translationUtility';

import { checkTermsAndConditions, unCheckTermsAndConditions } from './termsAndCondtionsActionCreators';


class CheckoutTermsAndCondtions extends React.Component {
    constructor(props) {
        super(props);
        this.toggleTermsAndCondtions = this.toggleTermsAndCondtions.bind(this);
    }

    toggleTermsAndCondtions() {
        if (this.props.termsAndConditions) this.props.unCheckTermsAndConditions();
        else this.props.checkTermsAndConditions();
      }

    render() {
        //const termsUrl = this.props.IsStopWorkshop
        //    ? "https://www.consultdss.com/490e69/globalassets/assets/documents/terms-and-conditions-virtual-workshop.pdf"
        //    : this.props.termsAndConditionsUrl;

        const termsUrl = this.props.termsAndConditionsUrl;
       return (
        <div className={"mb-1" + (this.props.hidden ? " d-none " : "")}>
           <span
               
            >
                <input
                    type='checkbox'
                    checked={this.props.termsAndConditions}
                    id='tersAndCondtions'
                    readOnly={false}
                    onClick={this.toggleTermsAndCondtions}
                />
                <label
                    className='pl-1'
                    htmlFor='#tersAndCondtions'>
                    I accept the 
                       <a className='l.link-default-1' target="_blank" rel="noopener noreferrer" href={termsUrl}> Terms & Conditions</a>
                </label>
            </span>
        </div>
        );
    }
}

CheckoutTermsAndCondtions.propTypes = {
    termsAndConditions: PropTypes.bool,
    hidden: PropTypes.bool
}

const mapCheckoutTermsAndCondtionsStateToProps = (state) => {
    const termsAndConditionsUrls = (state.entities.CartItems || [])
        .map(item => item.TermsAndConditionUrl)
        .filter(Boolean);
    return {
        termsAndConditions: state.ui.termsAndConditions,
        // eslint-disable-next-line no-mixed-operators
        hidden: state.ui.onPaymentScreen || !!!(state.entities.CartItems && state.entities.CartItems.some(item => item.IsLicense) || state.entities.CartItems.some(item => item.IsStopWorkshop)),
        IsStopWorkshop: state.entities.CartItems.some(item => item.IsStopWorkshop),
        termsAndConditionsUrl: termsAndConditionsUrls
    };
}

const mapCheckoutTermsAndCondtionsDispatchToProps = (dispatch) => {
    return {
        checkTermsAndConditions: () => {
            dispatch(checkTermsAndConditions());
        },
        unCheckTermsAndConditions: () => {
            dispatch(unCheckTermsAndConditions());
        }
    }
}

const CheckoutTermsAndCondtionsContainer = connect(mapCheckoutTermsAndCondtionsStateToProps, mapCheckoutTermsAndCondtionsDispatchToProps)(CheckoutTermsAndCondtions);

export default CheckoutTermsAndCondtionsContainer
